module.exports = __webpack_public_path__ + "img/ic_profile_coin@2x.2c39b187.png";